import FormControl from 'common/components/FormControl/FormControl';
import FormScrollError from 'common/components/FormScrollError/FormScrollError';
import { useMemo, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import arrayMutators from 'final-form-arrays';
import EditHeader from 'common/components/EditHeader/EditHeader';
import useRouter from 'common/hooks/use-router';
import HeaderButtonsEdit from 'common/components/EditHeader/HeaderButtonsEdit';
import DepartmentSelect from 'components/select/DepartmentSelect/DepartmentSelect';
import SectionTitle from 'common/components/SectionTitle/SectionTitle';
import { BsPersonVcardFill } from 'react-icons/bs';
import WarningIcon from 'components/Icon/icons/WarningIcon';

function EstablishmentForm({ onSubmit, establishment }: any) {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const [errorMessage, setErrorMessage] = useState('');
  const initialValues = useMemo(
    () =>
      establishment?.id
        ? {
            ...establishment,
            department: establishment.department?.id,
          }
        : {
            name: '',
            trainings: [],
            department: '',
          },
    [establishment]
  );

  const onSubmitWrapper = async (values: any) => {
    const res = await onSubmit(values);

    if (res.message) {
      setErrorMessage(res.message);
    }
  };

  return (
    <Form
      onSubmit={onSubmitWrapper}
      mutators={{
        ...arrayMutators,
        setFieldValue: ([field]: any, state: any, utils: any) => {
          utils.changeValue(state, field.field, () => field.value);
        },
      }}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      render={({ handleSubmit, values }) => {
        return (
          <div className="mx-auto max-w-full py-6 px-6 text-slate-500 text-base">
            {/* Header */}
            <EditHeader
              title={t(establishment?.id ? 'editItem.establishment' : 'newItem.establishment')}
              subTitle={values.name}
              icon={values.id ? 'TbBellSearch' : 'TbBellPlus'}
              errorMessage={errorMessage}
              HeaderButtonsEdit={
                <HeaderButtonsEdit
                  inHeader
                  onSubmit={handleSubmit}
                  onCancel={() => navigate('/establishments')}
                />
              }
            />
            <form onSubmit={handleSubmit} noValidate>
              <FormScrollError />

              <div className="responsive-flex gap-2 mt-2">
                <div className="md:w-full mb-2 md:mb-0">
                  <div className="flex flex-col gap-2 w-full">
                    <div className="white-box">
                      <div className="responsive-flex gap-8 p-2">
                        <div className="flex flex-col w-full gap-2">
                          <div className="flex flex-row w-full gap-4">
                            <FormControl
                              name="name"
                              titleKey="forms.name"
                              required
                              containerStyle="flex flex-col w-full mb-4"
                              className="text-input"
                            />
                            <FormControl
                              name="department"
                              titleKey="forms.department"
                              required
                              containerStyle="flex flex-col w-full mb-4"
                              className="text-input"
                              type="custom"
                            >
                              <DepartmentSelect
                              /* excludeIds={values.department || values.department?.id} */
                              />
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="white-box">
                      <div className="responsive-flex gap-8 p-2">
                        <div className="flex flex-col w-full gap-2">
                          <SectionTitle
                            title={t('forms.referentOperators')}
                            className="text-slate-500"
                          />
                          <div className="flex flex-col gap-1">
                            {establishment?.referentOperators?.length > 0 ? (
                              establishment?.referentOperators?.map((operator: any) => (
                                <div
                                  onClick={() => navigate(`/mediators/${operator.id}`)}
                                  className="white-box responsive-flex-lg flex-1 py-3 cursor-pointer"
                                >
                                  <div className="flex flex-row w-full items-center gap-2 mb-1 text-xl flex-wrap">
                                    <BsPersonVcardFill className="w-6 h-6 mr-2 text-primary" />
                                    <span className="font-bold text-primary leading-4">
                                      {operator.username}
                                    </span>
                                    {' - '}
                                    <span className="leading-4">{operator.firstname}</span>
                                    <span className="leading-4">{operator.lastname}</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="flex flex-row items-center gap-2 text-lg ml-4 italic text-danger-500">
                                <WarningIcon className="w-6 h-6 text-danger-500" />
                                {t('forms.noReferentOperators')}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <HeaderButtonsEdit
                onSubmit={handleSubmit}
                onCancel={() => navigate('/establishments')}
              />
            </form>
          </div>
        );
      }}
    />
  );
}
export default EstablishmentForm;
